import { IconType } from './types';

export const LivestreamIcon = ({ size = 24, color = 'black' }: IconType) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 7h18v10H3z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9 10 4 2-4 2V10z"
      fill={color}
    />
    <circle
      cx="18"
      cy="6"
      r="2"
      stroke={color}
      strokeWidth={1.5}
      fill="none"
    />
    <circle
      cx="18"
      cy="6"
      r="1"
      fill={color}
    />
  </svg>
);
